import { Text, View } from 'react-native';

export default function AccountInformation() {
  return (
    <View>
      <Text>Account Information</Text>
    </View>
  );
}
